<template>
    <!-- 运输 -->
    <div class="Minister-top information">
        <div class="Minister-top-top Ministerbackground">
            <div class="Minister-top-left Minister-top-color">运输</div>
        </div>
        <div class="information_content" style="margin-bottom: 20px">
            <div class="information_input mT-20" v-for="(item, index) in titleList" :key="index">
                <div class="information_Title">
                    <div class="item">
                        <span class="tips" v-if="item.required == 1">*</span>
                        {{ item.titleChinese }}
                    </div>
                    <div class="item">{{ item.name }}</div>
                </div>
                <div class="input_el">
                    <div class="newipt d-f">
                        <div style="width: 100%" v-for="(items, index) in topShuxingArr[index]" :key="index">
                            <el-date-picker class="shuxing_input"
                                v-if="items.oneOfValue != null && items.oneOfValue == 'date'"
                                v-model="items.publishProduct" :placeholder="'请选择' + items.titleChinese"
                                format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd">
                            </el-date-picker>
                            <el-input :disabled="isChakan || system < 5"
                                v-else-if="items.enumValue == null && items.type == 'string'" class="shuxing_input"
                                autosize :placeholder="'请输入' + items.titleChinese" v-model="items.publishProduct"
                                show-word-limit :type="items.maxLength == null ? 'input' : 'textarea'"
                                :maxlength="items.maxLength">
                            </el-input>
                            <el-input :disabled="isChakan || system < 5"
                                v-else-if="items.type == 'integer' || items.type == 'number' && items.enumValue == null"
                                class="shuxing_input" autosize :placeholder="'请输入' + items.titleChinese"
                                v-model="items.publishProduct" show-word-limit type="number" :max="items.maximum"
                                @input="numberInput(items)" :maxlength="items.maxLength">
                            </el-input>
                            <el-select :router="true" class="shuxing_input" v-else v-model="items.publishProduct"
                                clearable filterable :placeholder="'请选择' + items.titleChinese">
                                <el-option v-for="selectItem in items.enumValue" :key="selectItem" :label="selectItem"
                                    :value="selectItem">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { ajaxGet, ajaxPost, Baseurl } from "@/api/api/api";
export default {
    components: {},
    data() {
        return {
            topShuxingArr: [],
            titleList: []
        };
    },
    props: {
        isChakan: {
            type: Boolean,
            default: false,
        },
        system: {
            type: Number,
            default: 5,
        },
    },
    methods: {
        getData() {
            // 返回所有当前 data
            return { ...this.$data };
        },
        resetData() {
            // 用 Object.assign 替换 this 上的数据为初始状态
            Object.assign(this.$data, this.$options.data.call(this));
        },
        numberInput(items) {
            if(items.maximum){
                if (parseFloat(items.publishProduct) > items.maximum) {
                    items.publishProduct = items.maximum
                }
            }
        },
    },
};
</script>
<style lang="scss" scoped>
@import "../../../AllegroProductAllegro/ozon.less";

.input {
    width: 61.86133vw;
}

.select {
    width: 12.1vw;
}

.shuxing_input {
    width: 100%;
}
.information_Title{
    width: 200px !important;
    margin-right: 10px !important;
}
.input_el{
    width: calc(100% - 210px) !important;
}
.information_input{
    display: flex;
    align-items: center;
}
</style>